import React from "react";
import { View, StyleSheet, Modal } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../components/common/general/CustomButton/CustomButton";
import { useFocusTrap } from "../../../hooks/useFocusTrap";

const ExitBeforeCompletedModal = ({ visible, onConfirm, onCancel }) => {
  const { trapRef: modalRef } = useFocusTrap({ visible, onEscape: onCancel });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      accessibilityViewIsModal={true}
      onRequestClose={onCancel}>
      <View style={styles.centeredView}>
        <View
          ref={modalRef}
          role="dialog"
          aria-modal={true}
          aria-label="Confirm exit assessment"
          accessibilityLabel="Confirm exit assessment"
          style={styles.modalView}>
          <CustomText
            role="heading"
            aria-level={1}
            accessibilityRole="header"
            text="Hold it right there!"
            size="xxl"
            weight="ultraBold"
            style={{ color: "#101828", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText
            text="If you exit the assessment, the test will be ended. You won't be able to restart the test."
            size="l"
            weight="normal"
            style={{ color: "#344054", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText
            role="alert"
            text="Are you sure you want to exit?"
            size="l"
            weight="ultraBold"
            style={{ color: "#344054", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomSpacing type="vertical" size="xxl" />
          <View style={styles.buttonBox}>
            <CustomButton
              aria-label="Exit the assessment permanently"
              accessibilityLabel="Exit the assessment permanently"
              accessibilityRole="button"
              text="Yes, Exit Anyway"
              onPress={onConfirm}
              styleType="primary"
              style={styles.exitButton}
              textStyle={{ fontWeight: "700", fontSize: 18, fontFamily: "Inter" }}
            />
            <CustomButton
              aria-label="Stay in assessment"
              accessibilityLabel="Stay in assessment"
              accessibilityRole="button"
              text="Stay in Assessment"
              textStyle={{ fontWeight: "700", fontSize: 18, fontFamily: "Inter", color: "#3E68FE" }}
              onPress={onCancel}
              styleType="primaryLight"
              style={styles.cancelButton}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 20,
    padding: 40,
    height: "auto",
    maxWidth: 688,
    width: "auto",
    backgroundColor: "white",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
  },
  exitButton: {
    backgroundColor: "#3E68FE",
    borderRadius: 8,
    padding: 16,
  },
  cancelButton: {
    backgroundColor: "#fff",
    borderRadius: 8,
    borderWidth: 2,
    padding: 16,
    borderColor: "#3E68FE",
  },
});

export default ExitBeforeCompletedModal;
